"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assoc = void 0;
function assoc(...args) {
    if (args.length !== 3) {
        return function curriedAssoc(o) { return assoc(o, ...args); };
    }
    else {
        const [o, k, v] = args;
        return Object.assign(Object.assign({}, o), { [k]: v });
    }
}
exports.assoc = assoc;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXNzb2MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvYXNzb2MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBR0EsU0FBZ0IsS0FBSyxDQUFDLEdBQUcsSUFBVztJQUNoQyxJQUFJLElBQUksQ0FBQyxNQUFNLEtBQUssQ0FBQyxFQUFFO1FBQ25CLE9BQU8sU0FBUyxZQUFZLENBQUMsQ0FBTSxJQUFJLE9BQVEsS0FBYSxDQUFDLENBQUMsRUFBRSxHQUFHLElBQUksQ0FBQyxDQUFBLENBQUEsQ0FBQyxDQUFDO0tBQzdFO1NBQU07UUFDSCxNQUFNLENBQUMsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUMsR0FBRyxJQUFJLENBQUM7UUFDdkIsdUNBQVksQ0FBQyxLQUFFLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxJQUFFO0tBQzFCO0FBQ0wsQ0FBQztBQVBELHNCQU9DIn0=